// libs
import { styled } from '@nykaa/ui-components';
import { Link } from 'react-router-dom';
import { BREAKPOINTS } from 'shared/styles/base';

export const Wrapper = styled.div`
  position: relative;
  margin: ${({ theme }) => `0 0 ${theme.spacing.spacing80} 0`};
  border-top: 1px solid ${({ theme }) => theme.colors.textOutline};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    max-width: 560px;
  }
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    width: 100vw;
    margin-left: -16px;
    padding: ${({ theme }) => ` 0 ${theme.spacing.spacing80}`};
  }
`;

export const Heading = styled.h2`
  ${({ theme }) => theme.typography.titleMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: ${({ theme }) => `${theme.spacing.spacing120} 0 ${theme.spacing.spacing60} 0`};
  text-transform: capitalize;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin: ${({ theme }) => `${theme.spacing.spacing160} 0 ${theme.spacing.spacing100}`};
    ${({ theme }) => theme.typography.titleLarge};
  }
`;

export const SummaryContainer = styled.section`
  padding-bottom: ${({ theme }) => theme.spacing.spacing100};

  .star-rating-container {
    line-height: unset;
    height: 24px;
  }
`;

export const Heading2 = styled.p`
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-transform: capitalize;
  margin: ${({ theme }) => `0 0 ${theme.spacing.spacing60}`};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin: ${({ theme }) => `0 0 ${theme.spacing.spacing60}`};
    ${({ theme }) => theme.typography.titleMedium};
  }
`;

export const Button = styled(Link)`
  width: 100%;
  height: 44px;
  margin: ${({ theme }) => `${theme.spacing.spacing120} 0 ${theme.spacing.spacing120} 0`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.typography.buttonMedium};
  text-decoration: none;
  padding: ${({ theme }) => ` ${theme.spacing.spacing50} ${theme.spacing.spacing80}`};
  border-radius: ${({ theme }) => theme.borders.mwebButtonBorderRadius};
  /* reviewCTA token: secondary in fashion (outlined), primary in dark (filled) */
  background: ${({ theme }) => theme.componentTokens?.reviewCTA?.background ?? 'transparent'};
  color: ${({ theme }) => theme.componentTokens?.reviewCTA?.color ?? theme.colors.surfaceInverse};
  border: ${({ theme }) => theme.componentTokens?.reviewCTA?.border ?? `1px solid ${theme.colors.textOutline}`};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin: ${({ theme }) => `${theme.spacing.spacing120} 0 ${theme.spacing.spacing160} 0`};
    ${({ theme }) => theme.typography.buttonLarge};
    border-radius: ${({ theme }) => theme.borders.buttonBorderRadius};
  }
`;

export const OffsetForScroll = styled.div`
  position: absolute;
  top: -75px;
  left: 0;
`;

export const BasedOnDark = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyMedium};
  margin: 0;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;

export const RatingCount = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleXLarge};
  margin: ${({ theme }) => `${theme.spacing.spacing40} 0`};

  .maxCount {
    color: ${({ theme }) => theme.colors.textDisabled};
    ${({ theme }) => theme.typography.type320};
  }
`;

export const BrandbookHelperText = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  ${({ theme }) => `
  color: ${theme.colors.textSecondary};
  margin: ${theme.spacing.spacing60} 0 ${theme.spacing.spacing100};
`};
`;

export const SummaryContainerV2 = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.reviewTagBackground};
    color: ${theme.colors.textPrimary};
    margin: ${theme.spacing.spacing60} 0 ${theme.spacing.spacing120};
    padding: ${theme.spacing.spacing80};
    border-radius: ${theme.borders.radius10};
    border: 1px solid ${theme.colors.textDecorative};
`};
  display: flex;
`;

export const SummaryContainerStar = styled.div`
  ${({ theme }) => theme.typography.titleXLarge};
  display: flex;
  flex: 1.33;
  .star-icon {
    margin-left: ${({ theme }) => theme.spacing.spacing20};
  }
`;

export const SummaryContainerRating = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  ${({ theme }) => `
    padding:  0 0 0 ${theme.spacing.spacing80};
    border-left: 1px solid ${theme.colors.textDecorative};
  `};
  flex-flow: column;
  display: flex;
  color: ${({ theme }) => theme.colors.subtextColor};
  .subtext {
    ${({ theme }) => theme.typography.bodySmall};
  }
  flex: 1;
`;

export const SummaryContainerReviewCount = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  flex: 1;
  ${({ theme }) => `
    padding:  0 0 0 ${theme.spacing.spacing80};
    border-left: 1px solid ${theme.colors.textDecorative};
  `};
  color: ${({ theme }) => theme.colors.subtextColor};
  display: flex;
  flex-flow: column;
  .subtext {
    ${({ theme }) => theme.typography.bodySmall};
  }
`;

export const BuyerPhotosWrapper = styled.div`
  diplay: flex;
  justify-content: space-between;
`;
